export default __webpack_public_path__ + "static/media/menu-circular-dark.2b4ab04e.png";